import { HttpErrorResponse } from '@angular/common/http';
import { Action } from '@ngrx/store';
import { AssociationListResponse } from '@services/back-office/model/associationListResponse';
import { PaginationModel } from '@shared/models/pagination.model';
import { AssociationSearchRequest } from "@services/back-office/model/associationSearchRequest";
import { PageAssociationListResponse } from "@services/back-office/model/pageAssociationListResponse";
import {PageNameResponse} from '@services/associations/model/pageNameResponse';
import {OrganizationRequest} from '@services/back-office/model/organizationRequest';

export enum AssociationsActionTypes {
  LoadAssociations = '[Associations] Load Associations',
  LoadAssociationsSuccess = '[Associations] Load Associations Success',
  LoadAssociationsFailure = '[Associations] Load Associations Failure',
  AddAssociations = '[Associations] Add Associations',
  AddAssociationsSuccess = '[Associations] Add Associations Success',
  AddAssociationsFailure = '[Associations] Add Associations Failure',
  EditAssociations = '[Associations] Edit Associations',
  EditAssociationsSuccess = '[Associations] Edit Associations Success',
  EditAssociationsFailure = '[Associations] Edit Associations Failure',
  BlockAssociations = '[Associations] Block Associations',
  ChangePage = '[Associations] Change Page',
  SetInitialPagination = '[Associations] Set Initial Pagination',
  SetFilter = '[Associations] Set Filter',
  ClearFilter = '[Associations] Clear Filter',
  SetInitialState = '[Associations] Set Initial State',
}

/** Load Associations */
export class LoadAssociations implements Action {
  readonly type = AssociationsActionTypes.LoadAssociations;
  constructor(public payload?: {dontShowLoading: boolean}) {}
}

export class LoadAssociationsSuccess implements Action {
  readonly type = AssociationsActionTypes.LoadAssociationsSuccess;
  constructor(public payload: PageAssociationListResponse | PageNameResponse) { }
}

export class LoadAssociationsFailure implements Action {
  readonly type = AssociationsActionTypes.LoadAssociationsFailure;
  constructor(public payload: {error: HttpErrorResponse}) { }
}

/** Add Associations */
export class AddAssociations implements Action {
  readonly type = AssociationsActionTypes.AddAssociations;
  constructor(public payload?: OrganizationRequest) {}
}

export class AddAssociationsSuccess implements Action {
  readonly type = AssociationsActionTypes.AddAssociationsSuccess;
  constructor(public payload: AssociationListResponse) { }
}

export class AddAssociationsFailure implements Action {
  readonly type = AssociationsActionTypes.AddAssociationsFailure;
  constructor(public payload: {error: HttpErrorResponse}) { }
}

/** Edit Associations */
export class EditAssociations implements Action {
  readonly type = AssociationsActionTypes.EditAssociations;
  constructor(public payload: {associationId: string, request: OrganizationRequest}) {}
}

export class EditAssociationsSuccess implements Action {
  readonly type = AssociationsActionTypes.EditAssociationsSuccess;
  constructor(public payload: AssociationListResponse) { }
}

export class EditAssociationsFailure implements Action {
  readonly type = AssociationsActionTypes.EditAssociationsFailure;
  constructor(public payload: {error: HttpErrorResponse}) { }
}
/** Block Associations */
export class BlockAssociations implements Action {
  readonly type = AssociationsActionTypes.BlockAssociations;
  constructor(public payload: {associationId: string}) {}
}

/** Change Page */
export class ChangePage implements Action {
  readonly type = AssociationsActionTypes.ChangePage;
  constructor(public payload: PaginationModel) { }
}

/** Set Initial Pagination */
export class SetInitialPagination implements Action {
  readonly type = AssociationsActionTypes.SetInitialPagination;
}

/** Set Filter */
export class SetFilter implements Action {
  readonly type = AssociationsActionTypes.SetFilter;
  constructor(public payload: AssociationSearchRequest) { }
}

/** Clear Filter */
export class ClearFilter implements Action {
  readonly type = AssociationsActionTypes.ClearFilter;
}

/** Set Initial State */
export class SetInitialState implements Action {
  readonly type = AssociationsActionTypes.SetInitialState;
}

export type AssociationsActions =
  | LoadAssociations
  | LoadAssociationsSuccess
  | LoadAssociationsFailure
  | AddAssociations
  | AddAssociationsSuccess
  | AddAssociationsFailure
  | EditAssociations
  | EditAssociationsSuccess
  | EditAssociationsFailure
  | ChangePage
  | SetInitialPagination
  | SetFilter
  | ClearFilter
  | SetInitialState
  ;

